import {
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    colors,
  } from "@mui/material";
  import { Box } from "@mui/system";
  import React from "react";
  import { Controller, useForm } from "react-hook-form";
  import styled from "styled-components";
  
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    //   border: "2px solid #000",
    boxShadow: 24,
    borderRadius: "10px",
    p: 0,
    pb: "10px"
  };
  const HeaderContainer = styled.div`
    width: 100%;
    background-color: #1dbfc1;
    text-align: center;
    border-radius: 10px;
    padding: 25px 10px;
    border-bottom: 2px solid #ffa800;
    margin: 0;
  `;
  const Form = styled.form`
    margin: 20px 0;
    padding: 15px 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    justify-content: space-between;
  `;
  
  const NewAssetModal = ({ handleClose, title}) => {
    const {
      register,
      handleSubmit,
      watch,
      formState: { errors },
    } = useForm({
      defaultValues: {
        name: "",
        description: "",
      },
    });
    const onSubmit = (data) => console.log(data);
    return (
      <Box sx={style}>
        <HeaderContainer>
          <Typography variant="h3">{title}</Typography>
        </HeaderContainer>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <TextField
            fullWidth
            label="Subject Name"
            required
            {...register("name", { required: "name is required" })}
            sx={{ gridColumn: "span 2" }}
          />

          <TextField
            fullWidth
            multiline
            rows={2}
            label="Description"
            required
            {...register("description", { required: "description is required" })}
            sx={{ gridColumn: "span 2", mb: "20px", mt: "10px" }}
          />

            <Button  type="submit" variant="contained" color="success">
              Save
            </Button>
            <Button onClick={handleClose} variant="contained" color="warning">
              Close
            </Button>

        </Form>
      </Box>
    );
  };
  
  export default NewAssetModal;
  